import nextI18nextConfig from '~/next-i18next.config'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { GetServerSideProps, NextPage } from 'next'
import { HtmlPageMetaContextService } from '~/components/HtmlPageMeta/HtmlPageMetaContextService'
import { MarketFaqPage } from '~/components/MarketPages/FaqPage'
import { FaqPageRouteProps, fromFaqPagePropsToViewModel } from '~/modules/PresentationAdapters/FaqPageAdapter'

export const getServerSideProps: GetServerSideProps = async (context) => {
  const locale = context.locale ? context.locale : nextI18nextConfig.i18n.defaultLocale
  const htmlPageMetaContextService = new HtmlPageMetaContextService(context)

  return {
    props: {
      htmlPageMetaContextProps: htmlPageMetaContextService.getProperties(),
      ...await serverSideTranslations(locale, [
        'user_tos',
        'app_menu',
        'faq',
        'footer',
      ]),
    },
  }
}

const FaqRoutePage: NextPage<FaqPageRouteProps> = (props) => {
  return <MarketFaqPage viewModel={ fromFaqPagePropsToViewModel(props) } />
}

export default FaqRoutePage
